import { Add as AddIcon } from "@mui/icons-material";
import { Box, Container, Fab, Tooltip, Typography } from "@mui/material";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import { PageHeader } from "src/components/page/PageHeader";
import { useTemplates, usePermissions } from "src/hooks";
import { useUsers } from "src/hooks/users";
import { UsersTable } from "src/components/UsersTable";
import type { UserPaginationParams } from "src/types";
import { useState } from "react";

export function UsersPage() {
  const { t } = useTranslation();
  const { data: permissions } = usePermissions();
  const [userPagination, setUserPagination] = useState<UserPaginationParams>({
    orderBy: "firstName",
    orderDirection: "asc",
    limit: 10,
    offset: 0,
  });

  const { data: templates } = useTemplates();
  const { data: usersPaginated, isLoading, isPreviousData, isFetching } = useUsers(userPagination);

  const showLoader = isLoading || (isPreviousData && isFetching);

  return render();

  function render() {
    if (!usersPaginated || !permissions || !templates) return null;

    return (
      <StyledContainer maxWidth="lg">
        <PageHeader>
          <Typography variant="h3" noWrap className="page-title">
            {t("title.userManagement")}
          </Typography>
          <Box display="flex" flexGrow={1} />

          <Tooltip title={t<string>("tooltip.newUser")} placement="left">
            <Fab className="button  fab" color="primary" aria-label="add" component={NavLink} to={"/users/new"}>
              <AddIcon />
            </Fab>
          </Tooltip>
        </PageHeader>
        <UsersTable
          showLoader={showLoader}
          className="users-table"
          usersPaginated={usersPaginated}
          userPaginationParams={userPagination}
          setUserPaginationParams={setUserPagination}
        />
      </StyledContainer>
    );
  }
}

const StyledContainer = styled(Container)`
  padding: ${({ theme }) => theme.spacing(3)};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;

  .page-title {
    margin-bottom: ${({ theme }) => theme.spacing(3)};
  }
  .button {
    & + .button {
      margin-left: ${({ theme }) => theme.spacing(1)};
    }
  }

  .page-title {
    margin-bottom: ${({ theme }) => theme.spacing(3)};
  }

  .users-table {
    height: 0;
    flex: 1 1 100px;
    .MuiTableContainer-root {
      height: 100%;
    }
  }

  .button {
    & + .button {
      margin-left: ${({ theme }) => theme.spacing(1)};
    }
  }
`;
